
import { Constants } from './constants';

export default class UserService
{
  constructor ( apiService, $q )
  {
    'ngInject';

    Object.assign( this, {
      apiService,
      $q
    } );

    this.user = null;
  }

  storeUserData ( data )
  {
    this.user = data;
  }

  resetPassword ( oldPassword, newPassword, confirmPassword )
  {

    return this.apiService.post( {
      url: Constants.usersResetPasswordUrl,
      data: {
        userName: this.user.userName,
        oldPassword,
        newPassword,
        confirmPassword
      }
    } )
      .then( res =>
      {
        if ( res.data.status !== 200 )
        {
          return {
            error: true,
            data: res.data.errors
          }
        } else
        {
          return {
            error: false,
            data: res.data
          }
        }
      } )
      .catch( error =>
      {
        console.log( error )
      } );

  }

  resetPasswordMessage ()
  {
    console.log( 're' );
  }

}


// WEBPACK FOOTER //
// ./client/app/services/user.service.js